module.exports = __webpack_public_path__ + "static/media/book-mock-small.60cf9529.png";